import { useStaticData } from '@mc/static-data-react'
import { PageSource } from '@mc/track-event'

import { SubcatCourses } from 'components/SubcatCourses'
import { EpisodeStaticData } from '../../[episodeSlug].page'

export const SubcatCoursesSection = () => {
  const {
    course,
    classSubcategories,
    primaryGrowthCatAndSubcat,
    otherClassesInSameSubcategories,
  } = useStaticData<EpisodeStaticData>()

  return (
    <SubcatCourses
      subcategories={classSubcategories}
      classes={otherClassesInSameSubcategories}
      course={course}
      primaryCategory={primaryGrowthCatAndSubcat.primaryCategory}
      pageSource={PageSource.EPISODE_PAGE}
    />
  )
}
